<template>
  <section id="build-service" class="hero">
    <video class="hero_bg" :src="buildBgMovie" :poster="buildBgImage" webkit-playsinline playsinline muted autoplay loop></video>
    <SectionContainer class="hero_container">
      <img class="hero_logo" :src="buildServiceLogo" alt="build service" role="heading" aria-level="1">
      <div class="hero_body">
        <div>
          <p>
            お客様と共にデジタルビジネスを探索・実装・発展させる<br/>
            伴走型テクノロジーコンサルティングサービス
          </p>
        </div>
      </div>
      <div class="hero_link">
        <LinkText href="/concept">view concept→</LinkText>
      </div>
    </SectionContainer>
  </section>
</template>

<script>
import buildServiceLogo from '../../assets/images/build_servie_logo@2x.png'
import SectionContainer from '../atoms/SectionContainer'
import LinkText from '../atoms/LinkText.vue'
import buildBgMovie from '../../assets/movies/bg_gradient.mp4'
import buildBgImage from '../../assets/images/gradation@2x.png'

export default {
  name: 'build-service',
  components: {
    SectionContainer,
    LinkText
  },
  props: {},
  data () {
    return {
      buildServiceLogo,
      buildBgMovie,
      buildBgImage
    }
  },
  computed: {}
}
</script>

<style scoped lang="scss">
@import '../../assets/stylesheets/variables';
@import '../../assets/stylesheets/mixins';

.hero {
  @include bpOnlyPc() {
    background-size: contain;
  }
  @include bpOnlySp() {
    background-size: cover;
  }
  background-repeat: no-repeat;
  background-position: left bottom;
  font-family: Hiragino Kaku Gothic ProN;
  position: relative;
  &--large {
    @include bpOnlyPc() {
      padding-bottom: calc(600px / 2);
    }
    @include bpOnlySp() {
      padding-bottom: calc(300px / 2);
    }
  }
  &_container {
    text-align: center;
  }
  &_logo {
    width: 100%;
    max-width: 600px;
  }
  &_body {
    margin-top: 86px;
    color: $white;
    div {
      margin: auto auto;
      display: block;
      p {
        display: inline-block;
        @include bpOnlyPc() {
          font-size: 30px;
          line-height: 52px;
        }
        @include bpOnlySp() {
          font-size: 18px;
          line-height: 26px;
        }
        text-align: left;
        letter-spacing: 0.065em;
      }
    }
  }
  &_title {
    @include bpOnlyPc() {
      font-size: 40px;
    }
    @include bpOnlySp() {
      font-size: 30px;
    }
    font-weight: bold;
    line-height: 1.4;
    letter-spacing: 0.1em;
  }
  &_link {
    @include bpOnlyPc() {
      margin-top: 146px;
      font-size: 20px;
    }
    @include bpOnlySp() {
      margin-top: 73px;
      font-size: 15px;
    }
  }
  &_bg {
    z-index: -1;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    height: 100%;
    width: 100%;
    object-fit: fill;
    background-color: #090831;
  }
}
</style>
